import React from 'react';
import './charts.css';

const POS = '#0066CC';
const NEG = '#b91c1c';

/** Signed values around a centre axis. `value` is -1..1.
 *
 *  Direction is carried by more than colour: a negative bar is drawn to the
 *  LEFT of centre and a positive one to the right (see `left` below), and the
 *  signed percentage next to each bar states it in words. `data-direction`
 *  itself is a `data-` attribute, invisible to sighted and screen-reader
 *  users alike -- it exists for tests, not as an accessibility affordance. */
export default function DivergingBars({ rows = [] }) {
  const direction = (v) => (v > 0 ? 'positive' : v < 0 ? 'negative' : 'zero');
  return (
    <div className="diverging">
      {rows.map((r) => {
        const pct = Math.min(Math.abs(r.value), 1) * 50;
        const dir = direction(r.value);
        return (
          <div key={r.key} className="diverging__row">
            <div className="diverging__label">{r.label}</div>
            <div className="diverging__track" style={{ position: 'relative', height: 18 }}>
              <div
                data-testid={`diverging-bar-${r.key}`}
                data-direction={dir}
                style={{
                  position: 'absolute',
                  left: r.value >= 0 ? '50%' : `${50 - pct}%`,
                  width: `${pct}%`,
                  height: 18,
                  background: r.value >= 0 ? POS : NEG,
                }}
              />
            </div>
            <div className="diverging__value">
              {r.value > 0 ? '+' : ''}{Math.round(r.value * 100)}%
            </div>
          </div>
        );
      })}
    </div>
  );
}
